import {
  getContextInstallId
} from "./chunk-25YRKMCN.mjs";
import {
  INSTALLATION_ID_KEY
} from "./chunk-ADSPBXJF.mjs";

// src/utils/ids/attach-install-id-to-url/attach-install-id-to-url.ts
function attachInstallIdToUrl(url) {
  try {
    const urlToMutate = new URL(url);
    const installationId = getContextInstallId();
    if (installationId) {
      urlToMutate.searchParams.set(INSTALLATION_ID_KEY, installationId);
    }
    return urlToMutate.toString();
  } catch (error) {
    return url;
  }
}

export {
  attachInstallIdToUrl
};
